import { Component, OnDestroy, OnInit } from '@angular/core';
import { BlurHelperService } from 'src/app/modules/core/helpers/blur-helper.service';
import { CommonService } from '../../service/common.service';
import { CommonModule } from '@angular/common';
import { MatMenuModule } from '@angular/material/menu';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FilterPipe } from '../../pipes/filter.pipe';
/* eslint-disable */

@Component({
    selector: 'nio-active-account',
    templateUrl: './active-account.component.html',
    styleUrls: ['./active-account.component.scss'],
    imports: [CommonModule, MatMenuModule, MatFormFieldModule, MatInputModule, FormsModule, MatButtonModule, MatIconModule, FilterPipe]
})
export class ActiveAccountComponent implements OnInit, OnDestroy {
  selectedAccount;
  $selectedAccountChanged;
  searchValue = '';
  constructor(public commonService: CommonService,
    public blurHelper: BlurHelperService,
    ) {}

  ngOnInit(): void {
    this.selectedAccount = this.commonService.selectedAccount?.Name;
    
    
    this.$selectedAccountChanged =
      this.commonService.selectedAccountChanged.subscribe((res) => {
        if (res) {
          this.selectedAccount = res['Name'];
        }
      });
  }

  selectAccount(account) {
    this.commonService.selectedAccountChanged.emit(account);
    this.resetSearch();
  }

  resetSearch() {
    setTimeout(() => {
      this.searchValue = '';
    }, 100);
  }

  ngOnDestroy() {
    this.$selectedAccountChanged?.unsubscribe();
  }
}
